module.exports = __webpack_public_path__ + "static/media/Universal_Practice_CMYK_White-300-100.cfdfff27.png";